export const cognitiveAssessmentsTranslation = {
  'cognitiveassessmentstranslations.title': 'Cognitive test',
  'cognitiveassessmentstranslations.cognitiveTestResults':
    'Cognitive test results',
  'cognitiveassessmentstranslations.cognitiveTestNoConsentBoxValue':
    'We cannot show you the results of the cognitive testing until you have given your consent. You can do this in',
}
